<template>
  <div class="trialLog">
    <!-- <div class="logBg" id="box" v-html="fileLogs" v-loading="loading"></div> -->
    <div class="wrapper" ref="wrapper" id="wrapper">
      <ol class="content" ref="container" id="container">
        <li class="item" v-for="(item, index) in dataList" :key="index">
          <div class="tag" v-html="item"></div>
          <!-- {{ item }} -->
        </li>
      </ol>
    </div>
  </div>
</template>
<script>
import { getTrialFileLogs, getFileSize } from "@/request/api";
import BScroll from "@better-scroll/core";
import Pulldown from "@better-scroll/pull-down";
import Pullup from "@better-scroll/pull-up";
import Mousewheel from "@better-scroll/mouse-wheel";
BScroll.use(Pulldown);
BScroll.use(Pullup);
BScroll.use(Mousewheel);
let interval;
export default {
  name: "trialLog",
  data() {
    return {
      fileLogs: "",
      loading: true,
      isFirstEnter: true,
      curSize: 0,
      bscroll: null,
      dataList: [],
      from: null,
      to: null,
      startPullDown: null,
      startPullUp: null,
      allDataList: [],
      pointSize: null,
      spaceSize: 30000,
    };
  },
  methods: {
    destroyInterval() {
      clearInterval(interval);
      interval = null;
    },
    scrollBottom() {
      if (this.bscroll) {
        const Lis = this.$refs.container.querySelectorAll("li");
        if (Lis?.length >= 1) {
          const item = Lis[Lis.length - 1];
          this.bscroll.scrollToElement(item, 0);
        }
        this.bscroll.refresh();
      }
    },
    async getFileLogs(isPullDown) {
      try {
        if (isPullDown) {
          if (this.allDataList.length >= 3) {
            const firstM = this.allDataList[0]
            this.startPullDown = firstM.from
          }
          this.from = this.startPullDown - this.spaceSize;
          if (this.from <= 0) {
            this.from = 0;
            this.destroyInterval();
          }
          this.to = this.startPullDown;
        } else {
          if (this.allDataList.length >= 3) {
            const lastM = this.allDataList[2]
            this.startPullUp = lastM.to
          } 
          this.from = this.startPullUp;
          this.to = this.from + this.spaceSize;
        }
        console.log("from = ", this.from, "to = ", this.to);
        const logs = await getTrialFileLogs(
          this.$route.params.bucket,
          this.$route.params.path,
          this.from,
          this.to
        );
        // console.log("logs = ", logs)
        if (logs.length == 0) {
          // this.destroyInterval();
          return
        }
        if (logs.length <= 50) {
          const isEmpty = logs.every(log => {
            return log == ""
          })
          if(isEmpty) {
            // this.destroyInterval();
            return
          }
        }
        if (logs.length > 0) {
          const item = {
            from: this.from,
            to: this.to,
            data: logs
          }
          if (isPullDown) {
            this.allDataList.unshift(item);
            if (this.allDataList.length > 3) {
              this.allDataList = this.allDataList.slice(0, 3)
            } 
            // this.dataList = logs.concat(this.dataList);
            this.startPullDown = this.from;
          } else {
            this.allDataList.push(item);
            if (this.allDataList.length > 3) {
              this.allDataList = this.allDataList.slice(this.allDataList.length - 3)
            }
            // this.dataList = this.dataList.concat(logs);
            this.startPullUp = this.to;
          }
          this.dataList = []
          this.allDataList.forEach(model => {
            this.dataList = this.dataList.concat(model.data)
          });
        }
      } catch (error) {
        console.log(error);
        // this.destroyInterval();
      }
    },
    intervalGetLogs() {
      if (!interval) {
        interval = setInterval(async () => {
          await this.getFileLogs(false);
          this.scrollBottom();
        }, 5000);
      }
    },
    initScroll() {
      const that = this;
      setTimeout(() => {
        this.$nextTick(() => {
          that.bscroll = new BScroll(that.$refs.wrapper, {
            //定义滚动器
            scrollY: true,
            click: true, //启用点击事件
            disableMouse: false,
            disableTouch: false,
            probeType: 3,
            mouseWheel: true,
            infinity: true,
            scrollbar: true,
            pullUpLoad: {
              //启用上拉配置
              threshold: 30, //上拉动作触发距离
            },
            pullDownRefresh: true,
          });
          // this.bscroll.scrollTo(0, this.bscroll.maxScrollY);
          this.scrollBottom();
          that.bscroll.on("pullingUp", async () => {
            console.log("pulling up。。。。。。");
            await that.getFileLogs(false);
            that.bscroll.finishPullUp();
            that.bscroll.refresh();
            that.intervalGetLogs();
          });
          that.bscroll.on("pullingDown", async () => {
            console.log("pulling down。。。。。");
            await that.getFileLogs(true);
            that.bscroll.finishPullDown();
            that.bscroll.refresh();
          });
          that.bscroll.on("scroll", (op) => {
            const scrollY = Math.abs(op.y);
            const maxY = Math.abs(that.bscroll.maxScrollY);
            const direction = that.bscroll.movingDirectionY;
            console.log(
              "scroll ...... movingDirectionY = ",
              that.bscroll.movingDirectionY,
              "directionY = ",
              that.bscroll.directionY
            );
            if (scrollY < maxY && direction == -1) {
              that.destroyInterval();
            }
          });
        });
      }, 1000);
    },
  },
  mounted() {
    this.initScroll();
  },
  async created() {
    this.loading = true;
    this.curSize = await getFileSize(
      this.$route.params.bucket,
      this.$route.params.path
    );
    //11978418
    // this.curSize = 11938418
    if (this.curSize >= 1) {
      this.curSize -= 1
    }
    this.startPullDown = this.curSize;
    this.startPullUp = this.curSize;
    this.to = this.curSize;
    console.log("this.curSize = ", this.curSize);
    await this.getFileLogs(this.curSize != 0);
    this.intervalGetLogs();
  },
  beforeUnmount() {
    this.destroyInterval();
  },
};
</script>
<style lang='less' scoped>
.trialLog {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
}
.logBg {
  width: 100%;
  height: calc(100vh - 180px);
  word-wrap: break-word;
  white-space: pre-wrap;
  overflow-x: hidden;
  scroll-behavior: auto;
  font-size: 16px;
  color: #383838;
  text-align: left;
  line-height: 1.5;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 40px;
  background-color: #f5f5f5;
}
.wrapper {
  background-color: #000000;
  color: #fff;
  width: 100%;
  // height: 690px;
  height: calc(100vh - 110px);
  padding: 10px 5px 10px 40px;
  overflow: hidden;
  .content {
    text-align: center;
    text-align: left;
    overflow: hidden; //新添加
    .item {
      line-height: 25px;
      .tag {
        word-wrap: break-word;
        white-space: pre-wrap;
      }
    }
  }
}
</style>
